/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateLeadInfoRequestState
 */
export interface CreateLeadInfoRequestState {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    name?: string;
    /**
     * 
     */
    code?: string;
    /**
     * 
     */
    country_id?: string;
}

/**
 * Check if a given object implements the CreateLeadInfoRequestState interface.
 */
export function instanceOfCreateLeadInfoRequestState(value: object): value is CreateLeadInfoRequestState {
    return true;
}

export function CreateLeadInfoRequestStateFromJSON(json: any): CreateLeadInfoRequestState {
    return CreateLeadInfoRequestStateFromJSONTyped(json, false);
}

export function CreateLeadInfoRequestStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateLeadInfoRequestState {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'code': json['code'] == null ? undefined : json['code'],
        'country_id': json['country_id'] == null ? undefined : json['country_id'],
    };
}

export function CreateLeadInfoRequestStateToJSON(json: any): CreateLeadInfoRequestState {
    return CreateLeadInfoRequestStateToJSONTyped(json, false);
}

export function CreateLeadInfoRequestStateToJSONTyped(value?: CreateLeadInfoRequestState | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'code': value['code'],
        'country_id': value['country_id'],
    };
}

